import { Button, Col, Form, Input, InputNumber, Row, Select, Space, Switch, Tag } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal'
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx'
import getList from '../../universal/getList';
import fetchApi from '../../../utils/api/fetchApi';
import systematic from '../../../config/systematic';

const NoPrintConfigurationEdit = (props: any) => {
    const [form] = Form.useForm(); //form 
    const { data } = props;


    const { sendPageData } = data;
    const { branchStoreId } = sendPageData


    /**打印单类型数据 */
    const [printTypeData, setPrintTypeData] = useState<Array<any>>([]);
    /**打印机数据 */
    const [printData, setPrintData] = useState<Array<any>>([]);

    /**分类数据 */
    const [shopTypeData, setShopType] = useState<Array<any>>([])
    /**门店菜数据 */
    const [branchStoreMenuWarehouseData, setBranchStoreMenuWarehouseData] = useState<Array<any>>([]);


    const ref = useRef<any>(undefined);
    /** 后端数据wmService */
    let wmService: any = systematic.wmService;
    const handleOk = (e: any) => {
        ref.current.handleOk();
    };

    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    useEffect(() => {
        if (ref.current) {
            console.log("ref...", ref);

            // eslint-disable-next-line react-hooks/exhaustive-deps
            wmService = ref.current.wmService;

        }
        const fetchData = async () => {
            fetchApi.GET(wmService, {
                apiId: "generalData",
                apiExtend: 'showList',
                apiVariable: "printOrderType",
            }).then(res => {
                if (res.success) {
                    setPrintTypeData(res.data)
                }
            })


            fetchApi.GET(wmService, {
                apiId: "shopType",
                apiExtend: 'showList',
                apiData: {
                    mountDataOptions: {
                        userMount: {
                            isDept: true,
                        }
                    },
                    branchStoreId
                }
            }).then(res => {
                if (res.success) {
            
                    setShopType(res.data)
                }
            })

            fetchApi.GET(wmService, {
                apiId: "branchStoreMenuWarehouse",
                apiExtend: 'showMenuList',
                apiData: {
                    mountDataOptions: {
                        userMount: {
                            isDept: true,
                        }
                    },
                    branchStoreId
                }
            }).then(res => {

                if (res.success) {

                    setBranchStoreMenuWarehouseData(res.data)
                }
            })
            // if (!sendPageData.deptId) {
            //     fetchApi.GET(wmService, {
            //         apiId: "dept",
            //         apiExtend: 'showList',
            //     }).then(res => {
            //         if (res.success) {

            //             setDeptData(res.data)
            //         }
            //     })
            // }
        }

        fetchData()
    }, [])

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'noPrintConfiguration',
    };

    return (
        <><WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '不打印列表'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={700}
            >
                <Form
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                    onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                            handleOk(e)
                        }
                    }}>
                    <Row >
                        <Col span={12}>
                            <Form.Item
                                label="id"
                                name="id">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="打印单类型"
                                name="printType"
                                rules={[{ required: true, message: '请选择打印单类型!' }]}
                            >
                                <Select
                                    showSearch
                                    placeholder="打印类型"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(printTypeData, 'name')}
                                </Select>
                            </Form.Item>
                        </Col>



                        <Col span={8}>
                            <Form.Item
                                label="分类"
                                name="shopTypeId"

                            >
                                <Select
                                    showSearch
                                    placeholder="分类"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.generalEx(shopTypeData, {
                                        itemName: "shopTypeName",
                                        includeNull: true
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                label="门店菜式"
                                name="branchStoreMenuWarehouseId"

                            >
                                <Select
                                    showSearch
                                    placeholder="门店菜式"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.generalEx(branchStoreMenuWarehouseData, {
                                        "itemName": "foodName",
                                        includeNull: true
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>



                        <Col span={8}>
                            <Form.Item
                                label="状态"
                                name="isUse"
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>


                    </Row>









                </Form>
            </AntDraggableModal>
        </>
    )
}

export default NoPrintConfigurationEdit;